"use client"

import { useT } from "@/lib/router"
import { SITE } from "@/lib/site"
import { jobOpenings } from "@/content/careers"
import { Icon, PageHeader, Section } from "@/components/ui"

export default function Careers() {
  const t = useT()
  return (
    <>
      <PageHeader
        crumbs={[{ label: t({ en: "Careers", ar: "الوظائف" }) }]}
        eyebrow={t({ en: "Careers", ar: "الوظائف" })}
        title={t({ en: "Build what comes next, with us.", ar: "شاركنا بناء ما هو قادم." })}
        lead={t({
          en: "Help us build digital solutions that simplify work and connect people, tools and ideas.",
          ar: "ساعدنا في بناء حلول رقمية تسهّل العمل وتربط الناس والأدوات والأفكار.",
        })}
      />
      <Section>
        <h2 className="brand-h2 font-medium text-ink">
          {t({ en: "Open positions", ar: "الفرص المتاحة" })}
        </h2>
        {jobOpenings.length ? (
          <div className="mt-8 grid gap-5 md:grid-cols-2">
            {jobOpenings.map((job) => (
              <article key={job.id} className="rounded-r16 border border-line p-7">
                <h3 className="text-xl font-medium text-ink">{t(job.title)}</h3>
                <p className="mt-3 text-sm text-blue">{t(job.location)} · {t(job.employment)}</p>
                <p className="mt-4 text-base leading-7 text-slate">{t(job.description)}</p>
                <a
                  href={`mailto:${SITE.careersEmail}?subject=${encodeURIComponent(t(job.title))}`}
                  className="mt-6 inline-flex min-h-11 items-center gap-2 rounded-r8 bg-blue px-5 py-2 text-white transition-colors hover:bg-ink"
                >
                  {t({ en: "Apply by email", ar: "قدّم عبر البريد" })}
                  <Icon name="mail" className="size-5" />
                </a>
              </article>
            ))}
          </div>
        ) : (
          <div className="mt-8 rounded-r16 bg-mist p-8 md:p-10">
            <span className="inline-flex size-12 items-center justify-center rounded-r8 bg-white text-blue">
              <Icon name="user" />
            </span>
            <h3 className="mt-5 text-xl font-medium text-ink">
              {t({ en: "No open positions at the moment.", ar: "لا توجد وظائف معلنة حاليًا." })}
            </h3>
            <p className="mt-3 max-w-2xl text-base leading-7 text-slate">
              {t({
                en: "New opportunities will appear here, with a notice on the website when positions become available.",
                ar: "سننشر الفرص الجديدة هنا، وسيظهر تنبيه داخل الموقع عند توفر وظائف.",
              })}
            </p>
          </div>
        )}
        <div className="mt-12 border-t border-line pt-8">
          <h2 className="text-2xl font-medium text-ink">
            {t({ en: "Introduce yourself", ar: "عرّفنا بنفسك" })}
          </h2>
          <p className="mt-3 max-w-2xl text-base leading-7 text-slate">
            {t({
              en: "Send your CV and a short introduction to our careers email.",
              ar: "أرسل سيرتك الذاتية ونبذة قصيرة عنك إلى بريد الوظائف.",
            })}
          </p>
          <a href={`mailto:${SITE.careersEmail}`} className="mt-5 inline-flex min-h-11 items-center gap-3 text-lg font-medium text-blue underline underline-offset-4">
            <Icon name="mail" className="size-5" />
            <bdi dir="ltr">{SITE.careersEmail}</bdi>
          </a>
        </div>
      </Section>
    </>
  )
}
